import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DropdownStateService {
  private openDropdownId = signal<string | null>(null);

  openDropdown(id: string) {
    this.openDropdownId.set(id);
  }

  closeDropdown() {
    this.openDropdownId.set(null);
  }

  isDropdownOpen(id: string): boolean {
    return this.openDropdownId() === id;
  }

  getOpenDropdownId(): string | null {
    return this.openDropdownId();
  }
}
